/**
 * 模板编辑路由
 */
const Index = () => import('../pages/Template')

export default [{
	path: '/template',
	name: 'template',
	component: Index
}]
